<template>
    <div class="col col-xl-9 order-xl-2 col-lg-12 order-lg-1 col-md-12 col-sm-12 col-12">
        <div class="clients-grid" ref="allDeals">
            <div v-masonry transition-duration="0.3s" item-selector=".sorting-item" v-if="allDeals.length > 0" class="row sorting-container" id="clients-grid-1" >

                <div v-for="(deal,index) in allDeals" :key="index" class="col col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 sorting-item worlds family politics">

                    <div class="ui-block" style="position: relative">
                        <div :id="'cover_story_' + index" class="cover-story"></div>
                        <article class="hentry post has-post-thumbnail">

                            <div class="post__author author vcard inline-items">
                                <img v-if="deal.business_logo !== null " :src="deal.business_logo" alt="author">

                                <div class="author-date">
                                    <a class="h6 post__author-name fn" href="#"> {{ deal.business_name !== null ? deal.business_name : deal.business_username }} </a>
                                    <div class="post__date">
                                        <time class="published" datetime="2004-07-24T18:18">
                                            {{ dateString(deal.offer_deal_date) }}
                                        </time>
                                    </div>
                                </div>

                                <div class="more"><svg class="olymp-three-dots-icon"><use xlink:href="/svg-icons/sprites/icons.svg#olymp-three-dots-icon"></use></svg>
                                    <ul class="more-dropdown">
                                        <li>
                                            <a @click="updateDeal(deal.offer_id,index)" data-toggle="modal"
                                               data-target="#deals-my-poll-update" href="javascript:;">Edit Deal</a>
                                        </li>
                                        <li>
                                            <a @click="deleteDeal(deal.offer_id,index)" href="javascript:;">Delete Deal</a>
                                        </li>
                                    </ul>
                                </div>

                                <div v-if="deal.fixture_home_team" style="width:100%;margin-top: 10px">
                                    <code class="bg-blue-light st"> {{ deal.fixture_home_team }} </code>
                                    <code class="bg-breez-light st"> {{ deal.fixture_away_team }} </code>
                                </div>

                            </div>

                            <h4 style="padding: 0 20px;text-decoration: underline;text-transform: capitalize">{{ deal.offer_name }}</h4>

                            <p>
                                <span style="width:100%" v-if="deal.offer_link">
                                    <a :href="deal.offer_link">{{ deal.offer_link }}</a>
                                    <br><br>
                                </span>
                                {{ deal.offer_description !== null ? $urlify(deal.offer_description) : '' }}
                            </p>

                            <div class="post-thumb">
                                <img v-if="deal.offer_file" :src="deal.offer_file" alt="photo">
                            </div>


                        </article>
                    </div>
                </div>

            </div>
            <div  v-else class="col col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 offset-3 text-center">
                <div class="space">
                    <div class="space-sm"></div>
                </div>
                <div class="ui-block">
                    <div
                            class="ui-block-content text-center"
                            style="padding: 50px 23px; border-top:solid 4px #08ddc1"
                    >
                        <h4 class="title" style="font-weight:bold">Opps! no deal yet</h4>
                        <p>It appears you have not created any deal yet</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ls from "../../localstorage";
    export default {
        name: "allDeals.vue",
        data() {
          return {
              allDeals: {},
              first_page_url: "",
              current_page: "",
              last_page: "",
              from: "",
              next_page_url: "",
              to: "",
          }
        },
        mounted() {
            this.getAllDeals();
            window.eventBus.$on("dealsFeed", val => {
                if (val === true) {
                    this.getAllDeals();
                }
                // console.log(val);
            })

            $("title").html("Deals | " + this.$store.state.projectName);

        },
        methods: {
            // update a deal
            updateDeal(id,index) {
                const data = {
                    offer_id: id,
                    index: index,
                    deal: this.allDeals[index]
                };
                window.eventBus.$emit("dealsUpdateMatchID", data)
            },
            // delete a deal
            deleteDeal(id,index) {
                $("#cover_story_" + index).show();
                let formData = new FormData();
                formData.append("offer_id", id);

                this.axios({
                    method: "post",
                    url: "deals/delete",
                    data: formData,
                    config: { headers: { "Content-Type": "multipart/form-data" } }
                })
                    .then(response => {
                        // console.log(response)
                        this.allDeals.splice(this.allDeals.indexOf(index), 1);
                        return response;
                    })
                    .catch(error => {
                        // console.log(error)
                        return error;
                    })
            },

            dateString(date) {
                return this.$getDateYear(date,{timestamp:true})
            },
            showLoading() {
                let loader = this.$loader(this, this.$refs.allDeals, {
                    loaderType: "spinner"
                });
                return loader;
            },
            // get all deals
            getAllDeals() {
                console.log('fefefef')
                let loader = this.showLoading();
                let userData = ls.getStorage("fansData");
                userData = userData[0];
                this.axios.get(`/deals/business/${userData.id}/7`)
                    .then(response => {
                        loader.hide();
                        console.log(response);
                        let allData = response.data.data.offers;
                        this.allDeals = allData.data;
                        this.first_page_url = allData.first_page_url;
                        this.current_page = allData.current_page;
                        this.last_page = allData.last_page;
                        this.from = allData.from;
                        this.next_page_url = allData.next_page_url;
                        this.to = allData.to;
                    })
                    .catch(error => {
                        loader.hide();
                        // console.log(error);
                        return error;
                    })
            },
        },
    }
</script>

<style scoped>
.st {
    padding: 7px 10px;
    color: #fff !important
}
</style>
